<!--show_legend: bool-->
<!--show_question: bool-->
<!--show_percentage: bool-->
<!--horizontal_display: bool-->
<!--vertical_display: bool-->
<!--legend_colors: list of colors-->
<!--section: list of sections-->
  <!--questions: list of questions-->
    <!--answers: list of answers-->
      <!--text: string-->
      <!--color: string-->
      <!--percent: integer-->

{{#each sections}}
<div class="container-fluid poll-results">
    {{#each questions}}
    <div class="question-section">

        {{#if ../../show_legend}}
        <div class="row legend">
            {{#each answers}}
            <div class="col-sm-8 col-sm-offset-2 col-md-8 col-md-offset-2 legend-item">
                <div class="legend-item-color" style="background-color: {{color}};"></div>
                <div class="legend-item-text"> {{t text}} </div>
            </div>
            {{/each}}
        </div>
        {{/if}}

        {{#if ../../vertical_display}}
        <div class="col-xs-10 col-sm-8 col-xs-offset-1 col-sm-offset-2 col-md-8 col-md-offset-2 vertical-display vertical-columns">
            {{#each answers}}
            <div class="vertical-column">
                <div style="background-color: {{color}}; height: {{percent}}%;">
                    <div class="text-center">{{percent}}%</div>
                </div>
            </div>
            {{/each}}
        </div>
        {{/if}}

        {{#if ../../horizontal_display}}
        <div class="col-xs-12 col-sm-12 horizontal-display horizontal-columns">
            <ul class="row">
                <li class="col-xs-5 col-sm-5 question-text">
                    {{text}}
                </li>
                <li class="col-xs-7 col-sm-7">
                    {{#each answers}}
                    <ul class="list-unstyled row answers-area">
                        <li class="col-xs-7 col-sm-7 horizontal-column-area">
                            <div class="row">
                                <p class="center" style="background-color: {{color}}; width:{{percent}}%; min-height: 10px;">
                                    {{#if ../../../show_percentage}}
                                        <span>{{percent}}%</span>
                                    {{/if}}
                                </p>
                            </div>
                        </li>
                        <li class="col-xs-5 col-sm-5 horizontal-column-text">
                            <p class="row">{{text}}</p>
                        </li>
                    </ul>
                    {{/each}}
                </li>
            </ul>
        </div>
        {{/if}}
    </div>
    {{/each}}
</div>
{{/each}}